import { Suspense, lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { RouteObject } from 'react-router';

import SidebarLayout from 'src/layouts/SidebarLayout';
import BaseLayout from 'src/layouts/BaseLayout';

import SuspenseLoader from 'src/components/SuspenseLoader';

const Loader = (Component) => (props) => (
  <Suspense fallback={<SuspenseLoader />}>
    <Component {...props} />
  </Suspense>
);

// Auth
const SignIn = Loader(lazy(() => import('src/content/pages/Auth/SignIn')));

// Groups
const Groups = Loader(lazy(() => import('src/content/pages/Groups/Groups')));
const AddGroup = Loader(lazy(() => import('src/content/pages/Groups/Add')));
const EditGroup = Loader(lazy(() => import('src/content/pages/Groups/Edit')));

// Etapas
const Etapas = Loader(lazy(() => import('src/content/pages/Etapas/Etapa')));
const AddEtapa = Loader(lazy(() => import('src/content/pages/Etapas/Add')));
//const EditEtapa = Loader(lazy(() => import('src/content/Etapas/Edit')));

// Categorias
const Categorias = Loader(lazy(() => import('src/content/pages/Categorias/Categoria')));
const AddCategoria = Loader(lazy(() => import('src/content/pages/Categorias/Add')));
//const EditCategoria = Loader(lazy(() => import('src/content/Categorias/Edit')));

// Etapas - Categorias
const AddEtapaCategoria = Loader(lazy(() => import('src/content/pages/EtapaCategoria/Add')));

// Status
const Status404 = Loader(lazy(() => import('src/content/pages/Status/Status404')));

// Producao
const Producao = Loader(lazy(() => import('src/content/pages/Tasks/Tasks')))
const EditProducao = Loader(lazy(() => import('src/content/pages/Tasks/Edit')));

//PCP
const PCP_OP = Loader(lazy(() => import('src/content/pages/PCP/PCP_OP')));
const PCP_EMBALAGEM = Loader(lazy(() => import('src/content/pages/PCP/PCP_Embalagem')));
const PCP_ENVASE = Loader(lazy(() => import('src/content/pages/PCP/PCP_Envase')));
const PCP_Busca = Loader(lazy(() => import('src/content/pages/PCP/PCP_Busca')));
const PCPStatus = Loader(lazy(() => import('src/content/pages/PCP/PCPStatus')))
const EditPCP = Loader(lazy(() => import('src/content/pages/PCP/Edit')));

const ControleEtapa = Loader(lazy(() => import('src/content/pages/Etapas/ControleEtapa')));

const Estoque = Loader(lazy(() => import('src/content/pages/Estoque/View')));

const CSV = Loader(lazy(() => import('src/content/pages/CSV/View')));
//Demonstrativo
//const Demostrativo = Loader(lazy(() => import('src/content/pages/Demostrativo/Demostrativo')))

// Calendario
const Calendario = Loader(lazy(() => import('src/content/pages/Calendario/Calendario')));

// Funcionários
const Funcionario = Loader(lazy(() => import ('src/content/pages/Employees/Funcionarios')));

const Grafos = Loader(lazy(() => import('src/content/pages/EtapaCategoria/ViewCategoriasEtapas')));

const AlterarEtapaCategoria = Loader(lazy(() => import('src/content/pages/EtapaCategoria/Alter')));

const CadastroFuncionario = Loader(lazy(() => import('src/content/pages/Funcionarios/Add')));

const TabelaEtapaCategoria = Loader(lazy(() => import('src/content/pages/EtapaCategoria/ViewTabela')));

const Produtos = Loader(lazy(() => import('src/content/pages/Produtos/Produtos')));

const routes: RouteObject[] = [
  {
    path: '',
    element: <BaseLayout />,
    children: [
      { path: '/', element: <Navigate to="/pcp_op" replace /> },
      { path: 'overview', element: <Navigate to="/pcp_op" replace /> },
      { path: 'signin', element: <SignIn /> },
      { path: '*', element: <Status404 /> }
    ]
  },
  {
    path: '',
    element: <SidebarLayout />,
    children: [
      // Groups
      { path: 'equipe', element: <Groups /> },
      { path: 'equipe_adicionar', element: <AddGroup /> },
      { path: 'equipe/edit/:id', element: <EditGroup /> },

      // Etapas
      { path: 'etapas', element: <Etapas /> },
      { path: 'etapas_adicionar', element: <AddEtapa /> },
      //{ path: 'etapas/edit/:id', element: <EditEtapa /> },

      // Categorias
      { path: 'categorias', element: <Categorias /> },
      { path: 'categorias_adicionar', element: <AddCategoria /> },
      //{ path: 'categorias/edit/:id', element: <EditCategoria /> }

      // EtapaCategoria
      { path: 'etapa_categoria_adicionar', element: <AddEtapaCategoria /> },

      { path: 'producao', element: <Producao/> },
      { path: 'producao/edit/:id', element: <EditProducao /> },

      //PCP
      { path: 'pcp_status', element: <PCPStatus/> },
      { path: 'pcp_op', element: <PCP_OP/> },
      { path: 'pcp_embalagem', element: <PCP_EMBALAGEM/> },
      { path: 'pcp_envase', element: <PCP_ENVASE/> },
      { path: 'pcp_busca', element: <PCP_Busca/> },
      { path: 'pcp/edit/:id', element: <EditPCP/> },

      { path: "controle-etapa/:etapa_id/:etapa_nome", element: <ControleEtapa/> },

      { path: "calendario", element: <Calendario/> },

      { path: "funcionarios", element: <Funcionario/> },

      { path: "grafos_categoria", element: <Grafos/> },

      { path: "etapa_categoria/edicao", element: <AlterarEtapaCategoria/> },

      { path: "funcionario/cadastro", element: <CadastroFuncionario/> },

      { path: "produtos", element: <Produtos/> },

      { path: "etapa_categoria/tabela", element: <TabelaEtapaCategoria/> },

      // BI

      { path: "estoque", element: <Estoque/> },
      { path: "csv", element: <CSV/> },

    ]
  }
];

export default routes;
